export default "__VITE_ASSET__swEUg3d___"